module.exports = __webpack_public_path__ + "static/media/banner_nobg.94d6d6b9.png";